import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import AddBasicProject from './sections/add.jsx';
import EditBasicProject from './sections/edit.jsx';


const BasicProjects = () => {
    const [projects, setProjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [projectId, setProjectId] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [departments, setDepartments] = useState([]);
    const [filterType, setFilterType] = useState('');

    const fetchBasicProjects = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/basic_project?page=${currentPage + 1}`)
            .then(response => {
                setProjects(response.data.projects.data);
                setPageCount(Math.ceil(response.data.projects.total / response.data.projects.per_page));
            })
            .catch(error => {
                console.error("Error fetching basic projects!", error);
                setProjects([]);
            });
    };

    const fetchDepartments = async () => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/department`)
            .then(response => {
                setDepartments(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setDepartments([]); 
            });
    }
    
    useEffect(() => {        
        fetchBasicProjects(currentPage);
        fetchDepartments();
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = projects.filter((item) => {
        const matchesName = item.name.toLowerCase().includes(filterText.toLowerCase());
        const matchesType = filterType ? parseInt(item.type) === parseInt(filterType) : true;
        return matchesName && matchesType;
    });

    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">Basic Projects</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Basic Projects</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#basic_project"><i className="fa-solid fa-plus"></i> Add Basic Project</Link>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search basic project..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3">
                        <select className="form-control"
                            value={filterType}
                            onChange={(event)=>{setFilterType(event.target.value)}}>
                                <option value="">Select Project Type</option>
                                {departments.map(dep => (
                                    <option key={dep.id} value={dep.id}>{dep.name}</option>
                                ))}
                                <option key="0" value="0">Visions</option>
                        </select>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Project Name</th>
                                                <th>Project Type</th>                                                
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((project) => (
                                                        <tr key={project.id}>
                                                            <td>{project.name}</td>
                                                            <td>{project.get_department !== null ? 
                                                                    project.get_department.name : 'Visions'
                                                                }
                                                            </td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setProjectId(`${project.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#edit_basic_project_${project.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3">No records found</td>
                                                    </tr>
                                                ) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <AddBasicProject list={fetchBasicProjects}/>
            <EditBasicProject list={fetchBasicProjects} projectId={projectId} />
        </>
    );
}

export default BasicProjects